<script lang="ts" setup>
import { computed, ref } from 'vue';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';

import 'swiper/css';
import 'swiper/css/navigation';

const swiperInstance = ref();
const IMAGE_OPTION = '';
const timeTable = {
  0: {
    hour: '8',
    minute: '30',
    meridiem: 'AM',
  },
  1: {
    hour: '8',
    minute: '50',
    meridiem: 'AM',
  },
  2: {
    hour: '10',
    minute: '00',
    meridiem: 'AM',
  },
  3: {
    hour: '1',
    minute: '30',
    meridiem: 'PM',
  },
  4: {
    hour: '4',
    minute: '00',
    meridiem: 'PM',
  },
  5: {
    hour: '6',
    minute: '00',
    meridiem: 'PM',
  },
};
const timeSilde = ['schedule_01-1', 'schedule_02', 'schedule_03', 'schedule_04', 'schedule_05', 'schedule_06'].map(
  (schedule) => `https://dvercorp-co-kr.imgix.net/dpost/home/${schedule}.png${IMAGE_OPTION}`
);
const timeSildeMobile = [
  'schedule_m-01-2@3x',
  'schedule_m_02',
  'schedule_m_03',
  'schedule_m_04',
  'schedule_m_05',
  'schedule_m_06-01',
].map((schedule) => `https://dvercorp-co-kr.imgix.net/dpost/home/${schedule}.png${IMAGE_OPTION}`);
const timeSelect = ref<0 | 1 | 2 | 3 | 4 | 5>(0);
const timeSelectInfo = computed(() => timeTable[timeSelect.value]);

const timeControlNext = () => {
  if (timeSelect.value === 5) return;
  timeSelect.value++;
  swiperInstance.value.slideNext();
};
const timeControlPrev = () => {
  if (timeSelect.value === 0) return;
  timeSelect.value--;
  swiperInstance.value.slidePrev();
};

const onSlideChange = (swiper: any) => {
  timeSelect.value = swiper.activeIndex;
};
const onSwiper = (swiper: any) => {
  swiperInstance.value = swiper;
};
</script>

<template>
  <section class="howtouse container">
    <div class="howtouse__title">디포스트를 어떻게 {{ '\n' }} 이용하고 있을까요?</div>

    <!-- <div class="controller">
      <button class="bg-transparent" @click="timeControlPrev">
        <img
          class="h-full"
          :src="@/assets/image/arrow.svg')"
          alt="이전시간"
        />
      </button>

      <div class="controller__time" aria-label="디포스트 시간 별 사용">
        <div>Today</div>
        <div>{{ timeSelectInfo.hour }}</div>
        <div>{{ timeSelectInfo.minute }}</div>
        <div>{{ timeSelectInfo.meridiem }}</div>
      </div>

      <button class="bg-transparent" @click="timeControlNext">
        <img
          class="rotate-180 h-full"
          :src="@/assets/image/arrow.svg')"
          alt="다음시간"
        />
      </button>
    </div> -->

    <div class="schedule">
      <swiper
        :navigation="true"
        :slides-per-view="1"
        :space-between="10"
        :modules="[Navigation]"
        @swiper="onSwiper"
        @slideChange="onSlideChange"
      >
        <swiper-slide
          v-for="(item, index) in timeSilde"
          :key="item"
          class="mobile:hidden"
        >
          <img
            class="mx-auto desktop:w-[680px]"
            :src="item"
            :alt="`디포스트 한 눈에 보기${index}`"
          />
        </swiper-slide>

        <swiper-slide
          v-for="(item, index) in timeSildeMobile"
          :key="item"
          class="desktop:hidden"
        >
          <img
            class="mx-auto w-[280px]"
            :src="item"
            :alt="`디포스트 한 눈에 보기${index}`"
          />
        </swiper-slide>
      </swiper>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.howtouse {
  @apply flex flex-col gap-10;
  @apply desktop:gap-12;

  &__title {
    @apply text-3xl font-black text-center leading-[1.4] whitespace-pre-wrap;
    @apply desktop:whitespace-normal desktop:text-5xl;
  }
}

.controller {
  @apply px-3 pt-6 pb-5 flex justify-between items-center gap-4 w-full bg-black1 drop-shadow;
  @apply border-2 border-black2 rounded-[20px];
  @apply desktop:max-w-[690px] desktop:mx-auto desktop:px-8 desktop:pt-8 desktop:pb-7;

  img {
    @apply cursor-pointer;
  }
  &__time {
    @apply flex items-center justify-around w-full text-2xl font-semibold gap-3;
    @apply desktop:text-4xl;
  }
}

.schedule {
  @apply w-full;
  @apply bg-[url('https://dvercorp-co-kr.imgix.net/dpost/home/schedule_mobile_bg.png?auto=compress')] bg-no-repeat bg-contain bg-center;
  @apply desktop:bg-[url('https://dvercorp-co-kr.imgix.net/dpost/home/schedule_desktop_bg2.png?auto=compress')] desktop:pb-10 desktop:bg-contain desktop:pt-14;
}

:deep(.swiper-button-prev) {
  @apply w-10 h-10 desktop:w-20 desktop:h-20 -left-3;
  background: url('@/assets/image/silde-arrow-left.svg') no-repeat;
  background-size: 100%;
  background-position: center;

  &::after {
    display: none;
  }
}
:deep(.swiper-button-next) {
  @apply w-10 h-10 desktop:w-20 desktop:h-20 -right-3;
  background: url('@/assets/image/silde-arrow-right.svg') no-repeat;
  background-size: 100%;
  background-position: center;

  &::after {
    display: none;
  }
}
</style>
